module.exports = __webpack_public_path__ + "static/media/close.9a1a9237.svg";